import { reactive } from 'vue';

export const criarManifAssunto = () => {
    return reactive({
        id: 0,
        idmunicipio: 0,
        idtipo: 0,
        iddepartamento: 0,
        cdassunto: 0,
        nmassunto: '',
        detalhamento: '',
        ativo: 'S',
        ckexige_foto: 'N',
        ckexige_localizacao: 'N',
        ckpermite_anonimo: 'N',
        ckcidadao: 'N',
        ordem: 0,
        idlogin: 0
    });
};